import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  title: string;
  path: string;
  icon?: string;
  description?: string;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

// Text Watermark Removal Tools
export const textWatermarkTools: NavItem[] = [
  {
    title: 'ChatGPT Watermarks',
    path: '/remove-chatgpt-watermarks',
    icon: 'Bot',
    description: 'Remove ChatGPT text watermarks'
  },
  {
    title: 'Gemini Watermarks',
    path: '/remove-gemini-watermarks',
    icon: 'Sparkles',
    description: 'Remove Gemini text watermarks'
  },
  {
    title: 'Claude Watermarks',
    path: '/remove-claude-watermarks',
    icon: 'Target',
    description: 'Remove Claude text watermarks'
  },
];

// Image Watermark Removal Tools
export const imageWatermarkTools: NavItem[] = [
  {
    title: 'Gemini Images',
    path: '/remove-gemini-image-watermark',
    icon: 'Image',
    description: 'Remove Gemini image watermarks'
  },
];

// Document Cleaning Tools
export const documentTools: NavItem[] = [
  {
    title: 'DOCX Cleaner',
    path: '/document',
    icon: 'FileText',
    description: 'Clean DOCX documents'
  },
  {
    title: 'Pages Cleaner',
    path: '/document',
    icon: 'FileText',
    description: 'Clean Apple Pages documents'
  },
];

// Extensions and Student Tools
export const extensionTools: NavItem[] = [
  {
    title: 'Chrome Extension',
    path: 'https://chromewebstore.google.com/detail/gpt-watermark-remover/iaekbmafemcgololhmjgppedicomfnil',
    icon: 'Chrome',
    description: 'Browser extension'
  },
  {
    title: 'For Students',
    path: '/ai-watermark-remover-students',
    icon: 'GraduationCap',
    description: 'Watermark removal for students'
  },
];

// Resources Navigation
export const resourcesNavItems: NavItem[] = [
  {
    title: 'Knowledge Hub',
    path: '/knowledge',
    icon: 'BookOpen',
    description: 'In-depth guides and documentation'
  },
  {
    title: 'Blog',
    path: '/blog',
    icon: 'FileText',
    description: 'Latest news and updates'
  },
  {
    title: 'FAQ',
    path: '/faq',
    icon: 'HelpCircle',
    description: 'Frequently asked questions'
  },
  {
    title: 'About',
    path: '/about',
    icon: 'Info',
    description: 'Learn about our mission'
  },
];

// API Navigation
export const apiNavItems: NavItem[] = [
  {
    title: 'API Overview',
    path: '/api',
    icon: 'Code',
    description: 'Getting started with our API'
  },
  {
    title: 'Developer Docs',
    path: '/docs',
    icon: 'FileCode',
    description: 'Technical documentation'
  },
  {
    title: 'For Writing Tools',
    path: '/api/writing-tools',
    icon: 'PenTool',
    description: 'Integrate into writing apps'
  },
  {
    title: 'For Chatbots',
    path: '/api/chatbot-middleware',
    icon: 'MessageSquare',
    description: 'Add to chatbot platforms'
  },
  {
    title: 'For Content Platforms',
    path: '/api/content-platforms',
    icon: 'Layout',
    description: 'Power content creation tools'
  },
];

// Organize tools by section for the dropdown
export const toolsSections: NavSection[] = [
  {
    title: 'TEXT WATERMARK REMOVAL',
    items: textWatermarkTools
  },
  {
    title: 'IMAGE WATERMARK REMOVAL',
    items: imageWatermarkTools
  },
  {
    title: 'DOCUMENT TOOLS',
    items: documentTools
  },
  {
    title: 'EXTENSIONS',
    items: extensionTools
  },
];
